import {HistoryController} from "./historyController";
import DEBUG from "../DEBUG";

export abstract class HistoryStep {
    type;
    controller: HistoryController;
    viewDetails;
    cloneCreationWaiter;

    protected constructor(historyController, parameters) {
        this.type = parameters.type;
        this.controller = historyController;
        this.viewDetails = parameters.viewDetails;
        this.cloneCreationWaiter = {};
    }

    createCloneCreationWaiter(id, numberOfClonesToWaitFor, callback) {
        this.busy();
        this.cloneCreationWaiter[id] = {
            numberToWaitFor: numberOfClonesToWaitFor,
            callback: callback
        };
        this.checkAfterCloneCreation(id);
    }

    checkAfterCloneCreation(origId) {
        let callback;
        if (typeof (this.cloneCreationWaiter[origId]) === "undefined") {
            return;
        }
        const cloneIds = this.controller.selObController.getCloneIdsForOrigId(origId);
        if (cloneIds.length >= this.cloneCreationWaiter[origId].numberToWaitFor) {

            callback = this.cloneCreationWaiter[origId].callback;
            delete this.cloneCreationWaiter[origId];

            if (typeof (callback) === "function") {
                callback(cloneIds);
            }
            this.noLongerBusy();
        }
    }

    protected static deleteValueFromArray(value, arrayToProcess) {
        const index = arrayToProcess.indexOf(value);
        if (index > -1) {
            return arrayToProcess.splice(index, 1);
        }
        return arrayToProcess;
    }

    protected static replaceValueInArray(oldValue, newValue, arrayToProcess) {

        const index = arrayToProcess.indexOf(oldValue);
        if (oldValue === newValue) {
            if (DEBUG) {
                console.error("attempt to replace value in array with the same value " + oldValue);
            }
            return false;
        }
        if (index > -1) {
            arrayToProcess[index] = newValue;
            if (DEBUG) {
                console.log("replaced " + oldValue + " with " + newValue);
            }

            return true;
        }
        return false;
    }

    // noinspection JSUnusedGlobalSymbols
    cloneWasCreated(origId) {
        this.checkAfterCloneCreation(origId);
    }

    cloneWasDeleted(origId, newId) {
        //doNothing
    }

    replaceId(origId: string, newId: string): void {
        //do nothing
    }

    setEndStateSelOb(id: string) {
        //doNothing
    }

    busy = () => {
        if(this.controller.busySteps.indexOf(this) <0) {
            this.controller.busySteps.push(this);
        }

    }
    noLongerBusy = () => HistoryStep.deleteValueFromArray(this, this.controller.busySteps)

    abstract undo():void;

    abstract redo():void;
}